if (!customElements.get("ff-product-form")) {
  customElements.define(
    "ff-product-form",
    class FFProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.submitButton = this.querySelector('[type="submit"]');
        this.buttonText = this.submitButton?.querySelector(".ff-button-text");
        this.cart = document.querySelector(".ff-cart-drawer");

        // Enable variant input if present
        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.disabled = false;

        // Setup quantity controls
        this.setupQuantityControls();

        // Bind submit
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        // Listen for variant changes
        this.setupVariantListener();

        this.error = false;
      }

      /* ------------------------------
       * Variant Selection Handler
       * ------------------------------ */
      setupVariantListener() {
        document.addEventListener('variant-selector:change', (e) => {
          const { productId, selectedOptions, variant } = e.detail;
          
          // Check if this form belongs to the product being updated
          const formProductId = this.dataset.sectionId;
          if (formProductId !== productId) return;
          
          this.updateVariant(variant);
        });
      }

      updateVariant(variant) {
        if (!variant) return;
        
        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.value = variant.id;
        
        // Actualizar botón solo si NO está dentro de ff-buy-buttons
        // (ff-buy-buttons maneja su propia validación)
        if (this.submitButton && !this.closest('ff-buy-buttons')) {
          this.submitButton.disabled = !variant.available;
          this.submitButton.classList.toggle('ff-button-container--unavailable', !variant.available);
        }

        this.dispatchEvent(new CustomEvent('product-form:variant-changed', {
          detail: { variant },
          bubbles: true
        }));
      }

      /* ------------------------------
       * Quantity setup
       * ------------------------------ */
      setupQuantityControls() {
        // Si está dentro de ff-buy-buttons, no gestionar los controles de cantidad
        // (ff-buy-buttons los maneja centralmente para evitar listeners duplicados)
        const buyButtons = this.closest('ff-buy-buttons');
        if (buyButtons) {
          return;
        }
        
        const qtyInputSelector =
          this.dataset.quantityInput || ".ff-card-product__quantity-input";
        const qtyBtnSelector =
          this.dataset.quantityBtn || ".ff-card-product__quantity-btn";

        const useGlobalSearch =
          this.dataset.quantityInput || this.dataset.quantityBtn;

        if (useGlobalSearch) {
          this.quantityInput = document.querySelector(qtyInputSelector);
          this.decBtn = document.querySelector(
            `${qtyBtnSelector}[data-action="decrement"]`
          );
          this.incBtn = document.querySelector(
            `${qtyBtnSelector}[data-action="increment"]`
          );
        } else {
          this.quantityInput = this.querySelector(qtyInputSelector);
          this.decBtn = this.querySelector(
            `${qtyBtnSelector}[data-action="decrement"]`
          );
          this.incBtn = this.querySelector(
            `${qtyBtnSelector}[data-action="increment"]`
          );
        }

        this.attachQuantityHandlers();
      }

      attachQuantityHandlers() {
        if (!this.quantityInput) return;

        const STEP = Number(this.quantityInput.step || 1);
        const MIN = Number(this.quantityInput.min || 1);
        const hiddenInputSelector = this.dataset.quantityHidden;
        this.quantityHidden = hiddenInputSelector
          ? document.querySelector(hiddenInputSelector)
          : null;

        const clamp = (v) => Math.max(MIN, v);
        const setValue = (val) => {
          const newVal = clamp(Number(val));
          this.quantityInput.value = newVal;
          if (this.quantityHidden) this.quantityHidden.value = newVal;
        };

        this.decBtn?.addEventListener("click", () => {
          setValue(Number(this.quantityInput.value) - STEP);
        });

        this.incBtn?.addEventListener("click", () => {
          setValue(Number(this.quantityInput.value) + STEP);
        });

        this.quantityInput.addEventListener("input", () => {
          setValue(this.quantityInput.value);
        });

        // Inicializar valores
        if (this.quantityHidden) {
          this.quantityHidden.value = this.quantityInput.value;
        }
      }

      /* ------------------------------
       * Add to Cart
       * ------------------------------ */
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.submitButton.disabled ||
          this.submitButton.classList.contains("ff-button-container--blocked")
        )
          return;

        // The only job: delegate to cart service through cart.js
        // We emit a request through FfCartService with this form as the `source`
        FfCartService.add(this.form, { source: this });
        //FfCartService.update(this.form, { source: this });
      }

      /* ------------------------------
       * Lifecycle Hooks (called by cart.js)
       * ------------------------------ */

      ffCartLoading(operation) {
        if (operation !== "add") return;
        this.submitButton.disabled = true;
        this.submitButton.classList.add("ff-button-container--loading");
      }

      ffCartUpdated(cart, operation) {
        if (operation !== "add") return;
        this.error = false;
        this.submitButton.classList.remove("ff-button-container--loading");
        this.showSuccessState();
      }

      ffCartError(error, operation) {
        if (operation !== "add") return;
        this.error = true;
        console.error("Add to cart failed:", error);
        this.submitButton.classList.remove("ff-button-container--loading");
        this.submitButton.disabled = false;
      }

      /* ------------------------------
       * UI Feedback
       * ------------------------------ */
      showSuccessState() {
        if (!this.submitButton) return;

        const changeClass = !this.submitButton.classList.contains(
          "ff-button-container--success"
        );

        if (changeClass) {
          this.submitButton.classList.add("ff-button-container--success");
        }

        this.submitButton.style.pointerEvents = "none";
        const oldText = this.buttonText?.textContent;

        if (this.buttonText) {
          this.buttonText.textContent = "Añadido al carrito";
        }

        this.cart?.ffOpen?.();

        // Reset after 2s
        setTimeout(() => {
          if (changeClass)
            this.submitButton.classList.remove("ff-button-container--success");
          this.submitButton.style.pointerEvents = "";
          this.submitButton.disabled = false;
          if (this.buttonText && oldText) {
            this.buttonText.textContent = oldText;
          }
        }, 2000);
      }

      /* ------------------------------
       * Helpers
       * ------------------------------ */
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
